import { z } from "zod";

/** Hybrid logical clock used to order edits across devices. */
export const hybridClockSchema = z.object({
  wallTime: z.number().int().nonnegative(),
  counter: z.number().int().nonnegative(),
  deviceId: z.string().min(1).max(128)
});
export type HybridClock = z.infer<typeof hybridClockSchema>;

export function compareClocks(left: HybridClock, right: HybridClock): -1 | 0 | 1 {
  if (left.wallTime !== right.wallTime) return left.wallTime < right.wallTime ? -1 : 1;
  if (left.counter !== right.counter) return left.counter < right.counter ? -1 : 1;
  if (left.deviceId === right.deviceId) return 0;
  return left.deviceId < right.deviceId ? -1 : 1;
}

export function tickClock(
  deviceId: string,
  previous?: HybridClock,
  received?: HybridClock,
  now = Date.now()
): HybridClock {
  const wallTime = Math.max(now, previous?.wallTime ?? 0, received?.wallTime ?? 0);
  let counter = 0;
  if (previous?.wallTime === wallTime && received?.wallTime === wallTime) {
    counter = Math.max(previous.counter, received.counter) + 1;
  } else if (previous?.wallTime === wallTime) {
    counter = previous.counter + 1;
  } else if (received?.wallTime === wallTime) {
    counter = received.counter + 1;
  }
  return { wallTime, counter, deviceId };
}

export function makeId(prefix: string): string {
  return `${prefix}_${crypto.randomUUID()}`;
}
